import { render } from "./OptionDate.vue?vue&type=template&id=35f5073a"
import script from "./OptionDate.vue?vue&type=script&lang=js"
export * from "./OptionDate.vue?vue&type=script&lang=js"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__